// src/sentry.js
import * as Sentry from '@sentry/vue';

export default function initSentry(app, router) {
  const mode = import.meta.env.MODE;
  const devMode = ['dev', 'test', 'pre'];
  const prodMode = ['production', 'pc2', 'matrixProd', 'onlinetest'];
  if (!prodMode.includes(mode)) return;
  Sentry.init({
    app,
    dsn: 'https://8759fcaba7d509c37d8fbbc71e5986f2@sentry.qtech.cn/3',
    SENTRY_ENVIRONMENT: devMode.includes(mode) ? mode : 'production',
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    release: __SENTRY_RELEASE__
  });
}
